/**
 * 타임라인 인뷰 애니메이션 컨트롤러.
 *
 * [data-fw-timeline] 컨테이너 하위의 [data-fw-timeline-item] 들을 IntersectionObserver 로
 * 감지해 순차적으로 `.visible` 클래스를 부여하고, [data-fw-timeline-line] 의 height 를
 * 뷰포트 진입한 아이템의 dot 위치까지 확장한다.
 *
 * CSS 계약: `.timeline-item.visible { ... }` 로 노출 애니메이션 정의.
 * dot 위치 계산은 `.timeline-dot` 셀렉터에 의존.
 */
export const TIMELINE_CONTROLLER_SCRIPT = `
<script data-fw-timeline-controller>
(function () {
  function getDotY(item) {
    var dot = item.querySelector('.timeline-dot');
    return dot ? dot.offsetTop + dot.offsetHeight / 2 + item.offsetTop : item.offsetTop + 19;
  }
  function init() {
    var containers = document.querySelectorAll('[data-fw-timeline]');
    for (var ci = 0; ci < containers.length; ci++) {
      var container = containers[ci];
      if (container.dataset.fwTimelineInit) continue;
      container.dataset.fwTimelineInit = '1';
      var items = container.querySelectorAll('[data-fw-timeline-item]');
      if (items.length === 0) continue;
      var line = container.querySelector('[data-fw-timeline-line]');
      var bgLine = container.querySelector('[data-fw-timeline-bg-line]');
      var firstDotY = getDotY(items[0]);
      var lastDotY = getDotY(items[items.length - 1]);
      if (bgLine) { bgLine.style.top = firstDotY + 'px'; bgLine.style.height = (lastDotY - firstDotY) + 'px'; }
      if (line) line.style.top = firstDotY + 'px';
      (function (itemsRef, lineRef, firstY) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var idx = Array.prototype.indexOf.call(itemsRef, entry.target);
            setTimeout(function () { entry.target.classList.add('visible'); }, idx * 200);
            if (lineRef) {
              setTimeout(function () {
                var currentDotY = getDotY(entry.target);
                var h = currentDotY - firstY;
                var cur = parseInt(lineRef.style.height || '0', 10);
                if (cur < h) lineRef.style.height = h + 'px';
              }, idx * 200);
            }
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.2 });
        for (var i = 0; i < itemsRef.length; i++) observer.observe(itemsRef[i]);
      })(items, line, firstDotY);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=timeline.js.map